/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./blind.vue?vue&type=template&id=37621014&scoped=true"
import script from "./blind.vue?vue&type=script&lang=js"
export * from "./blind.vue?vue&type=script&lang=js"
import style0 from "./blind.vue?vue&type=style&index=0&id=37621014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37621014",
  null
  
)

export default component.exports